import React                   from 'react';
import { Route, Routes }       from 'react-router-dom';
import { AboutMemberDetailed } from './about/AboutMemberDetailed';
import { ContactDetails }      from './contacts/ContactDetails';
import { ContactsSummary }     from './contacts/ContactsSummary';
import { DocumentDetails }     from './documents/DocumentDetails';
import { DocumentsSummary }    from './documents/DocumentsSummary';
import { MyFamilyCore }        from './MyFamilyCore';
import { TaskDetails }         from './tasks/TaskDetails';
import { TasksSummary }        from './tasks/TasksSummary';

export const MyFamilyCoreRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<MyFamilyCore />}
    />

    <Route
      path="/about"
      element={<AboutMemberDetailed />}
    />

    <Route
      path="/documents"
      element={<DocumentsSummary />}
    />

    <Route
      path="/documents/:documentId"
      element={<DocumentDetails />}
    />

    <Route
      path="/tasks"
      element={<TasksSummary />}
    />

    <Route
      path="/tasks/:taskId"
      element={<TaskDetails />}
    />

    <Route
      path="/contacts"
      element={<ContactsSummary />}
    />

    <Route
      path="/contacts/:contactId"
      element={<ContactDetails />}
    />
  </Routes>
);
